<template>
    <CRow>
        <CCol col>
            <div id="derivedCurveLog">
                <div style="width:100%; height: 80vh;">
                    <ejs-grid ref='grid' :dataSource="derivedCurveLogsData" :allowFiltering='true' :allowPaging="true"
                              :allowResizing='true' :toolbarClick='toolbarClick' :allowExcelExport='true'
                              :excelExportComplete='excelExportComplete' :allowReordering='true' :allowSorting='true'
                              :toolbar='toolbar' :pageSettings='pageSettings' :actionBegin='actionBegin' :excelQueryCellInfo='excelQueryCellInfo'
                              :actionFailure="actionFailure" :filterSettings='filterOptions' width="100%" height="100%" :queryCellInfo='queryCellInfo'>
                        <e-columns>
                            <e-column field='derivedCurveLogId' headerText='Id' width=120 :isPrimaryKey='true' :visible='false'></e-column>
                            <e-column field='derivedCurveIdentifier' headerText='Identifier' textAlign='Left' width=150 type="string"></e-column>
                            <e-column field='state' headerText='Country' textAlign='Left' width=110 type="string"></e-column>
                            <e-column field='product' headerText='Product' textAlign='Left' width=110 type="string"></e-column>
                            <e-column field='fieldType' headerText='Field Type' textAlign='Left' width=200 type="string"></e-column>
                            <e-column field='fieldName' headerText='Field Name' textAlign='Left' width=150 type="string"></e-column>
                            <e-column field='parameterValue' headerText='Par. Value' textAlign='Left' type="number" format="n3" width=130></e-column>
                            <e-column field='parameterPeriodId' headerText='Period Id' textAlign='Left' type="number" format="n0" width=130></e-column>
                            <e-column field='action' headerText='Action' textAlign='Left' width=100 type="string"></e-column>
                            <e-column field='startDate' headerText='Start Date' textAlign='Left' width=130 type="date" :format='dateFormatOptions'></e-column>
                            <e-column field='endDate' headerText='End Date' textAlign='Left' width=130 type="date" :format='dateFormatOptions'></e-column>
                            <e-column field='userName' headerText='Created By' textAlign='Left' width=250 type="string"></e-column>
                            <e-column field='timeStampDate' headerText='Time Stamp' textAlign='Left' type='date' width=140 :format='dateFormatOptions'></e-column>
                            <e-column field='timeStampTime' headerText='Time' textAlign='Left' width=100 type="string"></e-column>
                        </e-columns>
                    </ejs-grid>
                </div>
            </div>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from "vue";
    import { GridPlugin, Toolbar, Page, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey } from "@syncfusion/ej2-vue-grids";
    import { Query } from '@syncfusion/ej2-data';
    import { DialogUtility } from '@syncfusion/ej2-popups';
    import gridOptions from '../../../common/gridOptions'
    import SyncHelper from '../../../common/syncfusion'
    import store from '../../../store';
    import { createSpinner, hideSpinner } from '@syncfusion/ej2-popups';

    Vue.use(GridPlugin);
    export default {
        components: {
        },
        data() {
            return {
                store: store,
                derivedCurveLogsData: SyncHelper.getDataManager("DerivedCurve/getLogGrid"),
                pageSettings: { pageSizes: [10, 20, 50, 100], pageSize: 100, pageCount: 4 },
                toolbar: ['ExcelExport'],
                filterOptions: gridOptions.filterSettings,
                dateFormatOptions: { type: 'date', format: 'dd/MM/yyyy', max: new Date(), params: { max: new Date() } },
                dateTimeFormatOptions: { type: 'dateTime', format: 'dd/MM/yyyy HH:mm'},
            };
        },
        mounted() {
            createSpinner({
                target: document.getElementById('mainSpinner'),
                width: '50',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loadingPoup'
            });
        },
        methods: {
            toolbarClick(args) {
                gridOptions.excelExport(args, "Derived Curve Logs.xlsx", this.$refs);
            },
            excelExportComplete(args) {
                this.$refs.grid.hideSpinner();
            },
            actionBegin(args) {
                gridOptions.actionBegin(args, this.$refs);//add ,this.$refs)is always for filtering -> offset this.$refs
                if (args.requestType == 'refresh') {
                    hideSpinner(document.getElementById('mainSpinner'));
                }
            },
            actionFailure(args) {
                gridOptions.actionFailure(args);
                hideSpinner(document.getElementById('mainSpinner'));
            },
            onFocus: function (args) {
                this.$refs.dateObj.show();
            },
            queryCellInfo(args) {

                if (args.column.field === 'timeStamp') {
                    args.cell.textContent = this.convertUTCDateToLocalTime(args.data['timeStamp']);
                }
            },
            convertUTCDateToLocalTime(dateString) {
                const date = new Date(dateString)
                var newDate = new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
                return newDate.toLocaleTimeString();
            },
            excelQueryCellInfo(args) {

                if (args.column.field === 'timeStamp') {
                    args.value = this.convertUTCDateToLocalTime(args.data['timeStamp']);
                }
            },
            actionComplete: function (args) {
                gridOptions.actionComplete(args, this.$refs);

            },
        },
        computed: {

        },
        provide: {
            grid: [Page, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey]
        }
    };
</script>
